import { storyblokEditable } from '@storyblok/react/rsc'
import { clsx } from 'clsx'
import { type FC } from 'react'

import { useBlockStyle } from '@redteclab/storyblok-style-field-plugin'

import { type StoryblokComponentProps } from '../../model'
import { type StoryblokSectionV2Type } from '../../storyblok'
import { StoryblokComponentsRenderer } from '../StoryblokComponentsRenderer'

export const StoryblokSectionV2: FC<
  StoryblokComponentProps<StoryblokSectionV2Type>
> = ({ blok }) => {
  const { content, id, style, variant } = blok

  const { blockClassName, blockStyle } = useBlockStyle(style)

  const children = <StoryblokComponentsRenderer bloks={content} />

  if (variant === 'content') {
    return (
      <section id={id} {...storyblokEditable(blok)} className="container">
        {children}
      </section>
    )
  }

  if (variant === 'landing') {
    return (
      <section
        {...storyblokEditable(blok)}
        className={clsx('py-9 desktop:py-12', blockClassName)}
        id={id}
        style={blockStyle}
      >
        <div className="container">{children}</div>
      </section>
    )
  }

  return null
}
